<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Role",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Datatable, Pagination, vSelect },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "70px",
        label: "ID",
        name: "id_role",
      },
      {
        width: "auto",
        label: "Role",
        name: "role_name",
      },
      {
        width: "auto",
        label: "Created At",
        name: "-",
      },
      {
        width: "150px",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Role",
      isRead: localStorage.getItem("isRead"),
      isWrite: localStorage.getItem("isWrite"),
      loadingTable: true,
      tableData: [],
      columns: columns,
      sortKey: "id_role",
      sortOrders: sortOrders,
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "id_role",
        dir: "desc",
        status: "ENABLE",
        name: "",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      formPayload: {},
      modalTambah: false,
      modalEdit: false,
      rowsMenu: [],
      rowsKodeTes: [],
      option_menu: [],
      option_pelaksanaan: [],
      option_kode_tes: [],
    };
  },
  mounted() {
    if (this.isWrite != 1) this.columns.pop();
    this.filterData = _.debounce(this.getTableData.bind(this), 500);
    this.getTableData();
  },
  methods: {
    addRowMenu() {
      this.rowsMenu.push({
        menu: "",
      });
    },
    removeRowMenu(index) {
      this.rowsMenu.splice(index, 1);
    },
    addRowKodeTes() {
      this.rowsKodeTes.push({
        idjadwal: "",
        kode_tes: "",
      });
    },
    removeRowKodeTes(index) {
      this.rowsKodeTes.splice(index, 1);
    },
    onSelectMenu(selectedId, index) {
      const selected = this.option_menu.find(
        (item) => item.menu === selectedId
      );
      if (selected) {
        this.rowsMenu[index].menu = selected.menu;
      }
    },
    onSelectKodeTes(selectedId, index) {
      const selected = this.option_kode_tes.find(
        (item) => item.idjadwal === selectedId
      );
      if (selected) {
        this.rowsKodeTes[index].idjadwal = selected.idjadwal;
        this.rowsKodeTes[index].kode_tes = selected.kode_tes;
      }
      this.rowsKodeTes = [...this.rowsKodeTes];
      console.log({kodetes: this.rowsKodeTes, selected});
    },
    async getTableData() {
      this.loadingTable = true;
      const data = await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/roles",
        params: this.tableFilter,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });
      if (data) {
        this.tableData = data.data.data;
        this.pagination.total = data.data.total;
        this.pagination.from = data.data.from;
        this.pagination.to = data.data.to;
        this.pagination.links = data.data.links;
        this.pagination.lastPageUrl = data.last_page_url;
        this.pagination.nextPageUrl = data.next_page_url;
        this.pagination.prevPageUrl = data.prev_page_url;
        this.pagination.per_page = this.tableFilter.per_page;
        this.pagination.page = this.tableFilter.page;
      }
      this.loadingTable = false;
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getTableData();
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getTableData();
    },
    create() {
      this.formPayload = {
        role_name: "",
        role_description: "",
      };
      this.modalTambah = true;
    },
    async store() {
      let payload = { ...this.formPayload };
      const data = await axios({
        method: "post",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/roles",
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err save data:", err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response.data.data,
          });
          return false;
        });
      if (data) {
        Swal.fire({
          icon: "success",
          title: "Data berhasil disimpan",
        });
        this.getTableData();
        this.modalTambah = false;
      }
    },
    edit(row) {
      this.rowsMenu.splice(0);
      this.rowsKodeTes.splice(0);
      // Tampilkan loading Swal
      Swal.fire({
        title: "Memuat data...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const data = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/roles/get-detail-edit/" +
          row.id_role,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      };

      // Isi formPayload dasar
      this.formPayload.id_role = row.id_role;
      this.formPayload.role_name = row.role_name;
      this.formPayload.role_description = row.role_description;

      axios(data)
        .then((response) => {
          const res = response.data.data || {};
          const data_hak_akses = res.hak_akses || [];
          const data_roles_data_akses = res.roles_data_akses || {};
          const data_list_hak_akses = res.list_hak_akses || [];
          const data_list_kode_tes = res.list_kode_tes || [];
          const data_jadwal_pelaksanaan = res.jadwal_pelaksanaan || [];

          // Set data menu & pelaksanaan
          this.option_menu = data_hak_akses;
          this.rowsMenu = data_list_hak_akses.map((item) => ({
            menu: item.menu,
          }));
          this.formPayload.menu = this.rowsMenu;

          this.option_pelaksanaan = data_jadwal_pelaksanaan;
          this.formPayload.idjadwal_pelaksanaan =
            data_roles_data_akses.jadwal_pelaksanaan_idjadwal_pelaksanaan;

          // Jika pelaksanaan tersedia, ambil kode tes
          if (this.formPayload.idjadwal_pelaksanaan) {
            this.getKodeTes(
              this.formPayload.idjadwal_pelaksanaan,
              data_list_kode_tes
            );
          }

          // Tutup loading Swal
          Swal.close();

          // Buka modal edit
          this.modalEdit = true;
        })
        .catch((error) => {
          console.error("Gagal mengambil data role:", error);
          Swal.fire({
            icon: "error",
            title: "Gagal memuat data",
            text: "Terjadi kesalahan saat mengambil data role.",
          });
        });
    },
    getKodeTes(idjadwal_pelaksanaan, selectedKodeTes = "") {
      const data = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/roles/get-kode-tes/" +
          idjadwal_pelaksanaan,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      };

      axios(data)
        .then((response) => {
          this.rowsKodeTes.splice(0);
          const data_jadwal = response.data.data;
          this.option_kode_tes = data_jadwal;
          if (selectedKodeTes) {
            this.rowsKodeTes = selectedKodeTes.map((item) => {
              return {
                kode_tes: item.jadwal_kode_tes,
                idjadwal: Number(item.jadwal_idjadwal),
              };
            });
          }
          this.formPayload.kode_tes = this.rowsKodeTes;
        })
        .catch((error) => {
          console.error("Gagal mengambil data jadwal:", error);
        });
    },
    async update() {
      const menu = this.formPayload.menu || [];
      const hasMenu = Array.isArray(menu) && menu.length > 0;

      const hasJadwal = !!this.formPayload.idjadwal_pelaksanaan;

      const kodeTes = this.formPayload.kode_tes || [];
      const hasKodeTes = Array.isArray(kodeTes) && kodeTes.length > 0;

      // Periksa apakah ada salah satu yang terisi
      const anyFilled = hasMenu || hasJadwal || hasKodeTes;

      // Periksa apakah semuanya terisi
      const allFilled = hasMenu && hasJadwal && hasKodeTes;

      // Jika ada yang terisi tapi tidak semuanya terisi → invalid
      if (anyFilled && !allFilled) {
        Swal.fire({
          icon: "warning",
          title: "Data belum lengkap",
          text: "Menu, jadwal pelaksanaan, dan kode tes harus diisi semuanya jika salah satunya diisi.",
        });
        return;
      }

      // tidak boleh ada yang kosong
      const isEmptyMenu = menu.some(e => !e.menu);
      const isEmptyKodeTes = kodeTes.some(e => !e.idjadwal);

      if (isEmptyMenu || isEmptyKodeTes) {
        Swal.fire({
          icon: "warning",
          title: "Data belum lengkap",
          text: "Menu atau kode tes belum dipilih.",
        });
        return;
      }

      Swal.fire({
        title: "Menyimpan data...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      let payload = { ...this.formPayload };
      const data = await axios({
        method: "put",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/roles/" +
          payload?.id_role,
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err save data:", err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: err.response.data.data,
          });
          return false;
        });
      if (data) {
        Swal.fire({
          icon: "success",
          title: "Data berhasil diperbarui",
        });
        this.getTableData();
        this.modalEdit = false;
      }
    },
    destroy(id) {
      Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin menghapus data ini ?",
        text: "Data yang dihapus tidak dapat dipulihkan kembali.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "delete",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/roles/" + id,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err delete data:", err);
              Swal.fire({
                icon: "error",
                text: "Terjadi Kesalahan",
                title: "Silahkan coba kembali beberapa saat lagi",
              });
              return false;
            });
          if (data) {
            Swal.fire({
              icon: "success",
              title: "Data Berhasil dihapus",
            });
            this.getTableData();
          }
        }
      });
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="text-end">
                  <button
                    class="btn btn-success btn-sm"
                    @click="create()"
                    v-if="isWrite == 1"
                  >
                    <i class="fa fa-plus me-1"></i> Tambah
                  </button>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="form-group col-md-3">
                <label for="filterRole">Role</label>
                <input
                  type="text"
                  id="filterRole"
                  class="form-control"
                  placeholder="Filter Role"
                  v-model="tableFilter.name"
                  @input="filterData"
                />
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getTableData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i>
                      Loading
                    </td>
                  </tr>
                  <tr v-else-if="tableData.length < 1">
                    <td colspan="99" class="text-center">Data Empty</td>
                  </tr>
                  <tr v-else v-for="(row, index) in tableData" :key="index">
                    <td>{{ index + pagination.from }}</td>
                    <td>{{ row.id_role }}</td>
                    <td>{{ row.role_name }}</td>
                    <td>{{ formatDate(row.created_at) }}</td>
                    <td v-if="isWrite == 1">
                      <div class="btn-group">
                        <button
                          class="btn btn-warning btn-sm"
                          @click="edit(row)"
                          v-if="isWrite == 1"
                        >
                          <i class="fa fa-edit me-1"></i>
                          Edit
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          @click="destroy(row.id_role)"
                          v-if="isWrite == 1"
                        >
                          <i class="fa fa-trash me-1"></i> Hapus
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
              <Pagination
                :pagination="pagination"
                @to-page="toPage"
              ></Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
  <b-modal v-model="modalTambah" hide-footer title="Tambah Pengguna Aplikasi">
    <form @submit.prevent="store" class="needs-validation" novalidate>
      <div class="mb-3">
        <label for="formRole">Role</label>
        <input
          type="text"
          id="formRole"
          class="form-control"
          placeholder="Role..."
          v-model="formPayload.role_name"
        />
      </div>
      <div class="mb-3 text-end">
        <button type="submit" class="btn btn-primary btn-sm">
          <i class="fa fa-save"></i> Simpan
        </button>
      </div>
    </form>
  </b-modal>

  <b-modal v-model="modalEdit" hide-footer title="Edit Pengguna Aplikasi">
    <form @submit.prevent="update" class="needs-validation" novalidate>
      <div class="mb-3">
        <label for="formRole">Role</label>
        <input
          type="text"
          id="formRole"
          class="form-control"
          placeholder="Role..."
          v-model="formPayload.role_name"
        />
      </div>
      <div class="mb-3">
        <label for="formMenu">Menu</label>

        <table class="table table-striped table-condensed">
          <tbody class="text-center">
            <tr v-for="(row, index) in rowsMenu" :key="index">
              <td style="width: 10px">
                <button
                  class="btn btn-danger btn-sm"
                  type="button"
                  @click="removeRowMenu(index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
              <td>
                <v-select
                  :id="'formMenu-' + index"
                  v-model="row.menu"
                  :options="option_menu"
                  :clearable="false"
                  label="menu"
                  placeholder="Pilih Menu..."
                  :reduce="(menu) => menu.menu"
                  @update:modelValue="onSelectMenu($event, index)"
                >
                  <template #option="{ menu }">
                    {{ menu }}
                  </template>
                </v-select>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="d-grid gap-2">
                  <button
                    class="btn btn-success btn-sm"
                    type="button"
                    @click="addRowMenu()"
                  >
                    <i class="fa fa-plus me-3"></i> Tambah Menu
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mb-3">
        <label for="formRole">Pelaksanaan</label>

        <v-select
          id="formPelaksanaan"
          v-model="formPayload.idjadwal_pelaksanaan"
          :options="option_pelaksanaan"
          label="pelaksanaan"
          placeholder="Pilih Pelaksanaan..."
          :reduce="(pelaksanaan) => pelaksanaan.idjadwal_pelaksanaan"
          @update:modelValue="getKodeTes"
        />
      </div>
      <div class="mb-3">
        <label for="formRole">Kode Tes</label>

        <table class="table table-striped table-condensed">
          <tbody class="text-center">
            <tr v-for="(row, index) in rowsKodeTes" :key="index">
              <td style="width: 10px">
                <button
                  class="btn btn-danger btn-sm"
                  type="button"
                  @click="removeRowKodeTes(index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
              <td>
                <v-select
                  :id="'formKodeTes-' + index"
                  v-model="row.idjadwal"
                  :options="option_kode_tes"
                  :clearable="false"
                  label="kode_tes"
                  placeholder="Pilih Kode Tes..."
                  :reduce="(jadwal) => Number(jadwal.idjadwal)"
                  @update:modelValue="onSelectKodeTes($event, index)"
                >
                </v-select>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="d-grid gap-2">
                  <button
                    class="btn btn-success btn-sm"
                    type="button"
                    @click="addRowKodeTes()"
                  >
                    <i class="fa fa-plus me-2"></i> Tambah Kode Tes
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mb-3 text-end">
        <button type="submit" class="btn btn-primary btn-sm">
          <i class="fa fa-save"></i> Simpan
        </button>
      </div>
    </form>
  </b-modal>
</template>
